module.exports = __webpack_public_path__ + "img/recovery-card-neotag-banner.dcf34a8e.png";